(function (appComponents) {

	// rewrite, includin html dom, tags, values
	appComponents.services.advancedSearch = function (Components) {

		var advancedSearch = {};

		advancedSearch.name = "advancedSearch";


		Components.getComponentPrototype().extend(advancedSearch);

		advancedSearch._modals = advancedSearch._getService("modals");
		advancedSearch._helpers = advancedSearch._getService("helpers");

		var dontShowSearchBarPages = ["index"];

		advancedSearch.elements = {
			get topSearchBarCommon() {
				return $("[pc-container='advanced-search--top-search-bar']");
			}
		};

		advancedSearch.context = {
			flags: {
				get showTopSearchBar() {
					if (advancedSearch.elements.topSearchBarCommon.is(':visible')) {
						return true;
					} else {
						return false;
					}
				}
			},
		};


		advancedSearch.bindings = function () {
			advancedSearch._elements.body.on("submit", "form[pc-container='advanced-search--form']", function () {
				advancedSearch.handlers.onIndexSearchFormSubmit(this);
				$('#global-search').val('');
				return false;
			});
			// advanced search
			advancedSearch._elements.body.on("submit", "[pc-container^='advanced-search--modal-form']", function () {
				advancedSearch.handlers.onIndexSearchFormSubmit(this);
				return false;
			});

			// unify below
			advancedSearch._elements.body.on("change", '[pc-container="advanced-search--options"]', function (e) {
				var value = $(this).val();
				if (value != "") {
					advancedSearch.handlers.onAdvancedSearchChange(value);
					$(this).find("option:selected").prop("selected", false);
					$(this).trigger("change");
				}
			});

			advancedSearch._elements.body.on("click", "[pc-value^='advanced-search--options']", function () {
				var value = $(this).attr("pc-value");
				advancedSearch.handlers.onAdvancedSearchChange(value);
			});

			// from thinkdesign core
			advancedSearch._elements.header.on('click', '.search-webclick', function () {
				$('.searchInput').toggleClass('active');
				$('.mobile-searchicon > a').addClass('search-close-anchor');
				$('.close-icon').removeClass('dis-none');
				$('.search-webclick').addClass('dis-none');
				// $('.search-bnd').addClass('dis-block-search-form').show();
			});

			advancedSearch._elements.header.on("click", ".close-icon", function (e) {
				// var p = $(e.target).closest('.nav-right, .ui-autocomplete').length
				// if (!p) {
				$('#global-search').val('');
				$('.search-webclick').removeClass('dis-none');
				$('.close-icon').addClass('dis-none');
				$('.mobile-searchicon > a').removeClass('search-close-anchor');
				$('.searchInput').removeClass('active');
				$('.search-bnd').removeClass('dis-block-search-form');
				if ($(window).width() < 767) {
					$('.search-bnd').hide();
				}
				$('.login-notification-details').show();
				$('.nav-right').removeClass('nav-right-mob');
				// }
			});

			if ($(window).width() < 767) {
				$('.search-webclick').click(function () {
					$('.search-bnd').addClass('dis-block-search-form').show();
					$('.login-notification-details').hide();
					$('.nav-right').addClass('nav-right-mob');
				});
			}


		};

		var popupSearchModalFactory = function (name) {

			var fragments = {
				acSearchModal: {
					name: "advanced-search--options-ac",
					searchBy: "AC",
					template: advancedSearch.templates.modalFormAc,
					get el() {
						return $("[pc-container='advanced-search--ac-modal']");
					},
					updateNeeded: true,
				},
				dcSearchModal: {
					name: "advanced-search--options-dc",
					searchBy: "DC",
					template: advancedSearch.templates.modalFormDc,
					get el() {
						return $("[pc-container='advanced-search--dc-modal']");
					},
					updateNeeded: true,
				},
				competitorSearchModal: {
					name: "advanced-search--options-competitor",
					searchBy: "compcatalog",
					get el() {
						return $("[pc-container='advanced-search--competitor-modal']");
					},
					updateNeeded: false,
				},
			};

			var popupSearchModal = advancedSearch._utils.getObjectByName(name, fragments);

			popupSearchModal.show = function () {
				this.el.modal("show");
				// temp
				// coreBindings();
				advancedSearch._applyScript.base.select2();
			};

			popupSearchModal.hide = function () {
				this.el.modal("hide");
			};

			popupSearchModal.populateOptions = function () {

				if (!this.updateNeeded) {
					return $.Deferred().resolve();
				}
				return advancedSearch._api.searchResults.getLvMotorsFilterOptions(this.searchBy).then(function (res) {
					if (res && res.status == 200) {
						var context = res.body;
						var el = popupSearchModal.el.find("[pc-container='advanced-search--modal-form'] .dc-modal-body");
						var html = popupSearchModal.template(context);
						el.replaceWith(html);
					}
				});
			};

			return popupSearchModal;
		};

		advancedSearch.toggleTopSearchBar = function (flag) {
			if (flag) {
				advancedSearch.elements.topSearchBarCommon.show();
				if ($(window).width() < 767) {
					$('.search-bnd').hide();
				}
			} else {
				advancedSearch.elements.topSearchBarCommon.hide();
			}
		};

		advancedSearch.checkIfSearchBarNeeded = function () {
			var flag;

			if (dontShowSearchBarPages.indexOf(advancedSearch._page.title) > -1) {
				flag = false;
			} else {
				flag = true;
			}

			if (flag != advancedSearch.context.flags.showTopSearchBar) {
				advancedSearch.toggleTopSearchBar(flag);
			}
		};

		advancedSearch.openSearchBarOnInit = function () {
			$(".search-webclick").click();
		};

		advancedSearch.handlers = {
			onAdvancedSearchChange: function (component) {
				var popupSearchModal = new popupSearchModalFactory(component);
				popupSearchModal.populateOptions().then(function () {
					popupSearchModal.show();
				});
			},
			onIndexSearchFormSubmit: function (el, name) {

				var hasErrors = advancedSearch._helpers.checkFormForErrors(el);
				if (hasErrors) {
					advancedSearch._modals.error.show(advancedSearch._messages.formError);
					return;
				}

				var searchData = advancedSearch._utils.getFormData(el);
				searchData = advancedSearch._utils.removeEmptyProps(searchData);


				searchData.pageNumber = 1;
				searchData.searchResults = 10;

				var params = $.param(searchData);

				var pageData = app.pages.searchResults;

				advancedSearch._handlers.onSwitchToPage(pageData, params);

			},
			onControllerInitialized: function () {
				advancedSearch.checkIfSearchBarNeeded();
			}
		};

		advancedSearch.init = function () {
			advancedSearch._bindings();
			advancedSearch.openSearchBarOnInit();
			advancedSearch._events.registerHandler("controllerInitialized", advancedSearch.name, advancedSearch.handlers.onControllerInitialized);
		};

		return advancedSearch;

	};

	window.appComponents = appComponents;

})(window.appComponents || {});